import { render } from "./App.vue?vue&type=template&id=2f9ab24d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2f9ab24d&lang=less"

import exportComponent from "D:\\hym\\WEB\\交接项目\\盘古信息客户应用案例\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__